import { AfterViewInit, Component, OnInit, ViewEncapsulation } from '@angular/core';
import SwiperCore, {
  Autoplay,
  EffectCoverflow,
  EffectCube,
  EffectFade,
  EffectFlip,
  Navigation,
  Pagination,
  Swiper,
  SwiperOptions,
} from "swiper";
import * as AOS from 'aos';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '@services/app.service';
import { Subject, takeUntil } from 'rxjs';
import { ConfigService } from '@services/config.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AddNewProduct } from '@/models/add-new-product/add-new-product';
import { ProductDetailsByPagination } from "@/modals/product-details-page";
import { ToastrService } from "ngx-toastr";
import { CategoryDetails } from "@/models/category-details/category-details";


SwiperCore.use([Autoplay, Pagination, Navigation, EffectFade, EffectCube, EffectCoverflow, EffectFlip]);

@Component({
  selector: 'app-website',
  templateUrl: './website.component.html',
  styleUrl: './website.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class WebsiteComponent implements OnInit {

  destroy$: Subject<boolean> = new Subject<boolean>();

  // api-variables
  productDetailsByPagination: ProductDetailsByPagination;
  productDetails: AddNewProduct[] = [];
  allProducts: AddNewProduct[] = [];
  newArrivalProductDetails: AddNewProduct[] = [];
  liveProductDetails: AddNewProduct[] = [];
  // category
  categoryDetails: CategoryDetails[] = [];
  // image
  endpoint: string = ''

  page: number = 1;

  totalPages: number = 1;
  isLoading: boolean = false;

  selectedCategoryId: number | null = null;
  selectedSubCategoryId: number | null = null;
  hoveredCategoryId: number | null = null;

  // Category pills
  selectedCategoryPill: string = 'Full Saree Collection';
  categoryPills: { name: string; image: string; categoryId: number | null }[] = [];

  private readonly categoryImageMap: { [key: string]: string } = {
    'Full Saree Collection': 'assets/img/new/full saree.jpg',
    'Joint Saree Collection': 'assets/img/new/joint-saree.png',
    'Tops': 'assets/img/new/tops.png',
    'Chudithar Set': 'assets/img/new/chudithar-set.png',
    'Foot Wears': 'assets/img/new/foot-wear.png',
    'Others': ''
  };




  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private config: ConfigService,
    private appService: AppService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
  ) {
  }

  ngOnInit(): void {
    AOS.init();
    console.log("this.appService")
    this.getAllProducts();
    this.getCategoryDetailsAndBuildPills();
    this.getLiveProductDetails();
    this.endpoint = this.config.getConfig().END_POINT;

    // ✅ Listen to query params for category filtering from navbar
    this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe(params => {
      const categoryId = params['categoryId'] ? Number(params['categoryId']) : null;
      const subCategoryId = params['subCategoryId'] ? Number(params['subCategoryId']) : null;

      if (subCategoryId) {
        this.selectedCategoryId = categoryId;
        this.selectedSubCategoryId = subCategoryId;
        this.loadProductsBySubCategory(subCategoryId);
      } else if (categoryId) {
        this.selectedCategoryId = categoryId;
        this.selectedSubCategoryId = null;
        this.loadProductsByCategory(categoryId);
      } else if (Object.keys(params).length === 0) {
        this.selectedCategoryId = null;
        this.selectedSubCategoryId = null;
      }
      
      this.syncCategoryPill();
    });
  }

  onImageLoad(event: Event) {
    (event.target as HTMLImageElement).classList.add('is-loaded');
  }


  mainBanner: SwiperOptions = {
    slidesPerView: 2,
    spaceBetween: 0,
    loop: true,
    speed: 3000,
    effect: 'slide',
    autoplay: {
      delay: 4000,
      disableOnInteraction: true,
    },
    navigation: {
      nextEl: '.banner-swiper-button-next',
      prevEl: '.banner-swiper-button-prev',
    },
    breakpoints: {
      1440: { slidesPerView: 1 },
      1024: { slidesPerView: 1 },
      700: { slidesPerView: 1 },
      500: { slidesPerView: 1 },
      400: { slidesPerView: 1 },
      300: { slidesPerView: 1 },
    },
  };


  categoryConfig: SwiperOptions = {
    slidesPerView: 2,
    spaceBetween: 20,
    loop: false,
    effect: 'slide',
    breakpoints: {
      1440: {
        slidesPerView: 10,
      },
      1024: {
        slidesPerView: 10,
      },
      700: {
        slidesPerView: 6,
      },
      500: {
        slidesPerView: 3,
      },
      400: {
        slidesPerView: 3,
      },
      300: {
        slidesPerView: 3,
      },
    },
    navigation: {
      nextEl: '.cat-swiper-button-next',
      prevEl: '.cat-swiper-button-prev',
    },
  };

  newArrivalConfig = {
    slidesPerView: 5,
    spaceBetween: 20,
    navigation: {
      nextEl: '.new-arrivals-next',
      prevEl: '.new-arrivals-prev',
    },
    breakpoints: {
      320: { slidesPerView: 2 },
      576: { slidesPerView: 2.5 },
      768: { slidesPerView: 3 },
      992: { slidesPerView: 4 },
      1200: { slidesPerView: 5 },
    },
  };

  liveSaleConfig: SwiperOptions = {
    slidesPerView: 5,
    spaceBetween: 20,
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.live-sale-next',
      prevEl: '.live-sale-prev',
    },
    breakpoints: {
      320: { slidesPerView: 2 },
      576: { slidesPerView: 2.5 },
      768: { slidesPerView: 3 },
      992: { slidesPerView: 4 },
      1200: { slidesPerView: 5 },
    },
  };


  testimonialConfig: SwiperOptions = {
    slidesPerView: 2,
    spaceBetween: 20,
    loop: true,
    speed: 1500,
    effect: 'slide',
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    breakpoints: {
      1440: { slidesPerView: 1 },
      1024: { slidesPerView: 1 },
      700: { slidesPerView: 1 },
      500: { slidesPerView: 1 },
      400: { slidesPerView: 1 },
      300: { slidesPerView: 1 },
    },
    navigation: {
      nextEl: '.testimonial-next',
      prevEl: '.testimonial-prev',
    },
  };


  brandImagesConfig: SwiperOptions = {
    slidesPerView: 2,
    spaceBetween: 20,
    loop: true,
    speed: 1500,
    effect: 'slide',
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    breakpoints: {
      1440: { slidesPerView: 7 },
      1024: { slidesPerView: 6 },
      700: { slidesPerView: 4 },
      500: { slidesPerView: 3 },
      400: { slidesPerView: 2 },
      300: { slidesPerView: 2 },
    },
    navigation: {
      nextEl: '.testimonial-next',
      prevEl: '.testimonial-prev',
    },
  };


  bannerValue = [
    {
      "image": "../../../assets/img/new/banner2.jpg",
    },
    {
      "image": "../../../assets/img/new/banner3.jpg",
    },
    {
      "image": "../../../assets/img/new/banner4.jpg",
    }
  ]


  // testimonial = [
  //   {
  //     "image": "assets/img/bottom-banner-3.jpg",
  //     "description": "These are great quality eye glasses and I love how you can choose the lens power for each eye. I searched the internet for a while and this is the only company I found that did that.",
  //     "name": "LEAH JOHN",
  //     "role": "Fashion"
  //   },
  //   {
  //     "image": "assets/img/bottom-banner-2.jpg",
  //     "description": "These are great quality eye glasses and I love how you can choose the lens power for each eye. I searched the internet for a while and this is the only company I found that did that.",
  //     "name": "LEAH JOHN",
  //     "role": "Fashion"
  //   },
  //   {
  //     "image": "assets/img/bottom-banner-1.jpg",
  //     "description": "Find Your Fit These are great quality eye glasses and I love how you can choose the lens power for each eye.",
  //     "name": "Get up to 50% off on top brands",
  //     "role": "Fashion"
  //   },
  // ]

  testimonial = [
    {
      "description": "Lovely Fashion in Villapuram is my go-to place for all things trendy and stylish! The variety of fabrics, designs, and colors is amazing. Every time I visit, I find something new that perfectly matches my style. The customer service is excellent, and I always leave with a smile on my face. Highly recommend this store to anyone looking for quality fashion at affordable prices!"
      ,
    },
    {
      "description": "I absolutely love shopping at Lovely Fashion! They have a fantastic collection of both traditional and modern wear, all at great prices. The staff is friendly and always makes sure I'm happy with my choices. The store has a welcoming vibe, and I never leave disappointed. A must-visit if you're in Villapuram or Madurai!",
    },
    {
      "description": "Lovely Fashion in Villapuram offers the best selection of clothes in Madurai! Whether it’s for a casual day out or a special occasion, I always find something that fits the occasion perfectly. The quality of the materials is top-notch, and the prices are just right. I love how every shopping experience feels personalized and special!",
    },
    {
      "description": "I had such a great shopping experience at Lovely Fashion, Villapuram! The store has a beautiful collection of clothing and accessories, and I was able to find exactly what I was looking for. The staff went above and beyond to help me choose the perfect outfit for a family event. Definitely my favorite fashion spot in Madurai!",
    },
    {
      "description": "Lovely Fashion is the best place to shop for all your fashion needs in Madurai! They have an incredible variety of clothing, from ethnic to western, all of which are stylish and high-quality. I’ve been a loyal customer for years, and each visit feels like a delightful experience. If you're in the area, you must check them out!",
    },
  ]


  productDetailViewNavigate(id: number) {
    if (!id) return;
    const encodedProduct = btoa(JSON.stringify(id)); // Encode entire object as Base64
    this.router.navigate(['/variant-view'], { queryParams: { product: encodedProduct } });
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    })

  }


  getAllProducts() {
    if (this.isLoading) return;
    this.isLoading = true;
    this.spinner.show();

    this.appService.getAllProductsByPagination(this.page)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data: ProductDetailsByPagination) => {
          this.spinner.hide();
          this.isLoading = false;

          console.log('Get All Products Response', data);
          this.productDetailsByPagination = data;
          this.totalPages = data.totalPages;

          const filteredProducts = (data.content || [])
            .filter(product =>
              product.availability !== 'No' &&
              product.variants?.some(variant => variant.isAvailable)
            )
            .map(product => ({
              ...product,
              variants: product.variants.filter(v => v.isAvailable)
            }))
            .sort((a, b) => b.productId - a.productId);

          // Store all products in a master list
          this.allProducts = [...this.allProducts, ...filteredProducts];

          // Apply category filter if active
          this.applyCategoryFilter();

          console.log('Filtered Product Details', this.productDetails);

          // Load new arrivals once (optional)
          if (this.page === 1) this.getRecentProductDetails();
        },
        error: (error: any) => {
          this.spinner.hide();
          this.isLoading = false;
          this.toastr.error(error.message || 'Products details not found');
          console.error("Something Went Wrong", error);
        }
      });
  }



  filterByCategory(categoryId: number | null) {
    this.selectedCategoryId = categoryId;
    this.selectedSubCategoryId = null;

    if (categoryId) {
      this.loadProductsByCategory(categoryId);
    } else {
      // Show all products when no category is selected
      this.productDetails = [...this.allProducts];
    }
  }

  onCategoryHover(categoryId: number) {
    this.hoveredCategoryId = categoryId;
  }

  onCategoryLeave() {
    this.hoveredCategoryId = null;
  }

  filterBySubCategory(subCategoryId: number) {
    this.selectedSubCategoryId = subCategoryId;
    this.loadProductsBySubCategory(subCategoryId);
  }

  /** Fetch products from API by category ID */
  private loadProductsByCategory(categoryId: number) {
    this.spinner.show();
    this.appService.getProductsByCategoryId(categoryId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data: AddNewProduct[]) => {
          this.spinner.hide();
          this.productDetails = (data || [])
            .filter(product =>
              product.availability !== 'No' &&
              product.variants?.some(variant => variant.isAvailable)
            )
            .map(product => ({
              ...product,
              variants: product.variants.filter(v => v.isAvailable)
            }))
            .sort((a, b) => b.productId - a.productId);
        },
        error: (error: any) => {
          this.spinner.hide();
          this.toastr.error(error.message || 'Failed to load products for this category');
        }
      });
  }

  /** Fetch products from API by subcategory ID */
  private loadProductsBySubCategory(subCategoryId: number) {
    this.spinner.show();
    this.appService.getProductsBySubCategoryId(subCategoryId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data: AddNewProduct[]) => {
          this.spinner.hide();
          this.productDetails = (data || [])
            .filter(product =>
              product.availability !== 'No' &&
              product.variants?.some(variant => variant.isAvailable)
            )
            .map(product => ({
              ...product,
              variants: product.variants.filter(v => v.isAvailable)
            }))
            .sort((a, b) => b.productId - a.productId);
        },
        error: (error: any) => {
          this.spinner.hide();
          this.toastr.error(error.message || 'Failed to load products for this subcategory');
        }
      });
  }

  applyCategoryFilter() {
    if (this.selectedSubCategoryId) {
      this.loadProductsBySubCategory(this.selectedSubCategoryId);
    } else if (this.selectedCategoryId) {
      this.loadProductsByCategory(this.selectedCategoryId);
    } else {
      this.productDetails = [...this.allProducts];
    }
  }

  getRecentProductDetails() {
    this.spinner.show();
    this.appService.getRecentProducts()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: any) => {
        this.spinner.hide();
        this.newArrivalProductDetails = data.sort((a: any, b: any) => b.productId - a.productId);
      }, (error: any) => {
        this.spinner.hide();
        this.toastr.error(error.message || "Something went wrong, please try again...")
      });
  }

  getLiveProductDetails() {
    this.appService.getLiveProducts()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: any) => {
        this.liveProductDetails = data.sort((a: any, b: any) => b.productId - a.productId);
      }, (error: any) => {
        console.error("Failed to load live products", error);
      });
  }

  // Triggered automatically by scroll
  onScrollDown() {
    if (this.page < this.totalPages) {
      this.page++;
      console.log('Loading next page:', this.page);
      this.getAllProducts();
    } else {
      console.log('No more pages to load');
    }
  }


  // category
  getCategoryDetails() {
    this.spinner.show();
    this.appService.getCategoryDetailsByActive()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: any) => {
        this.spinner.hide();
        console.log("Get Category Details", data);
        this.categoryDetails = data;
      }, (error: any) => {
        console.error("Something Went Wrong", error);
      })
  }

  /** Fetch categories and build the pills list, then auto-select default */
  getCategoryDetailsAndBuildPills() {
    this.spinner.show();
    this.appService.getCategoryDetailsByActive()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: any) => {
        this.spinner.hide();
        this.categoryDetails = data;

        // Target category names for the pills
        const targetNames = [
          'Full Saree Collection',
          'Joint Saree Collection',
          'Tops',
          'Chudithar Set',
          'Foot Wears'
        ];

        // Build pills from matching API categories
        this.categoryPills = targetNames
          .map(name => {
            const match = this.categoryDetails.find(
              c => c.categoryName?.toLowerCase().trim() === name.toLowerCase().trim()
            );
            if (match) {
              return {
                name: name,
                image: this.categoryImageMap[name] || '',
                categoryId: match.categoryId
              };
            }
            return null;
          })
          .filter(p => p !== null) as { name: string; image: string; categoryId: number | null }[];

        // Add "Others" pill at the end (shows all products)
        this.categoryPills.push({
          name: 'Others',
          image: '',
          categoryId: null
        });

        this.syncCategoryPill();
      }, (error: any) => {
        console.error("Something Went Wrong", error);
      });
  }

  /** Handle category pill click */
  onCategoryPillSelect(cat: { name: string; image: string; categoryId: number | null }) {
    this.selectedCategoryPill = cat.name;
    if (cat.categoryId) {
      this.filterByCategory(cat.categoryId);
    } else {
      // "Others" — show all products
      this.filterByCategory(null);
    }
  }

  syncCategoryPill() {
    if (this.categoryPills.length === 0) return;

    if (!this.selectedCategoryId && !this.selectedSubCategoryId) {
      const defaultPill = this.categoryPills.find(p => p.name === 'Full Saree Collection');
      if (defaultPill && defaultPill.categoryId) {
        this.selectedCategoryPill = defaultPill.name;
        this.filterByCategory(defaultPill.categoryId);
      }
    } else if (this.selectedCategoryId) {
      const activePill = this.categoryPills.find(p => p.categoryId === this.selectedCategoryId);
      if (activePill) {
        this.selectedCategoryPill = activePill.name;
      } else {
        this.selectedCategoryPill = 'Others';
      }
    }
  }


  getImageUrl(variants: any[]): string {
    const defaultImage = 'assets/img/my-1.jpg';

    if (!Array.isArray(variants) || variants.length === 0) {
      return defaultImage;
    }

    // Find PRIMARY + ACTIVE image
    for (const variant of variants) {
      if (!Array.isArray(variant.images)) continue;

      const primaryImage = variant.images.find(
        (img: any) => img.isPrimary === true && img.isActive === true
      );

      if (primaryImage?.imageDetailsId) {
        return `${this.endpoint}/api/product/image-details/get/${primaryImage.imageDetailsId}`;
      }
    }

    // Fallback: first ACTIVE image
    for (const variant of variants) {
      if (!Array.isArray(variant.images)) continue;

      const firstActive = variant.images.find(
        (img: any) => img.isActive === true
      );

      if (firstActive?.imageDetailsId) {
        return `${this.endpoint}/api/product/image-details/get/${firstActive.imageDetailsId}`;
      }
    }

    return defaultImage;
  }


  onImageError(event: Event) {
    const img = event.target as HTMLImageElement;
    img.src = 'assets/img/my-1.jpg';
  }


}
